import React from "react";
import PropTypes from "prop-types";

const CardWrapper = React.forwardRef(
  (
    {
      cardType,
      layoutVariation = "",
      children = null,
      className = "",
      elementTag = "div",
      type = "default",
      ...rest
    },
    ref
  ) => {
    const cardWrapperClass = `card__wrapper card__wrapper--${cardType} card__wrapper--${cardType}--${layoutVariation} ${className}`;
    const Element = elementTag;
    const elementProps = {
      className: cardWrapperClass,
      ...rest
    };

    if (ref) {
      elementProps.ref = ref;
    }

    return (
      <Element {...elementProps}>
        <div className="card">{children}</div>
      </Element>
    );
  }
);

CardWrapper.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  elementTag: PropTypes.string
};

export default CardWrapper;
